"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gql = _interopRequireDefault(require("../../../services/utils/gql"));
const getTokenUserQuery = (0, _gql.default)`
  query getTokenUserQuery {
    viewer {
      __typename
      ... on Unauthorized {
        reason
      }
      ... on User {
        ...Balances
        ...Inbox
        userId
        affiliateId
        socialAvatar
        avatar {
          url
        }
        locale {
          language {
            languageId
            code
          }
          currency {
            code
          }
        }
        hasPassword
        identity {
          email
          name {
            first
            last
            full
          }
          isVerified
        }
        referFriend {
          numberOfValidPromoCodes
        }
        vipSubscription {
          isEligible
          subscriptionDetails {
            endsAt
            isSubscribed
            startsAt
          }
        }
      }
    }
  }
  fragment Balances on User {
    creditBalance {
      creditAmounts {
        edges {
          node {
            amount
            currency {
              code
            }
          }
        }
      }
    }
  }

  fragment Inbox on User {
    inbox {
      numberOfUnreadMessages
    }
  }
`;
var _default = getTokenUserQuery;
exports.default = _default;